/** Bound memory while reusing instances by culture and normalized options. */
function cacheFormatter<Options extends object, Formatter>(create: (culture: string, options: Options) => Formatter) {
  const cache = new Map<string, Formatter>()
  return (culture: string, options: Options): Formatter => {
    const entries = Object.entries(options).filter(([, value]) => value !== undefined).sort(([a], [b]) => a.localeCompare(b))
    const key = JSON.stringify([culture, entries])
    let formatter = cache.get(key)
    if (!formatter) {
      formatter = create(culture, options)
      if (cache.size >= 128) cache.delete(cache.keys().next().value!)
      cache.set(key, formatter)
    }
    return formatter
  }
}

export const dateTimeFormatter = cacheFormatter((culture: string, options: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat(culture, options))
export const numberFormatter = cacheFormatter((culture: string, options: Intl.NumberFormatOptions) => new Intl.NumberFormat(culture, options))
export const relativeTimeFormatter = cacheFormatter((culture: string, options: Intl.RelativeTimeFormatOptions) => new Intl.RelativeTimeFormat(culture, options))
export const collator = cacheFormatter((culture: string, options: Intl.CollatorOptions) => new Intl.Collator(culture, options))
export const displayNames = cacheFormatter((culture: string, options: Intl.DisplayNamesOptions) => new Intl.DisplayNames([culture], options))
